/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientPlaylistModel } from '../../models/patient-playlist-model';

export interface GetPlaylists$Params {
  patientID?: number;
}

export function GetPlaylists(http: HttpClient, rootUrl: string, params?: GetPlaylists$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientPlaylistModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPlaylists.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientPlaylistModel>>;
    })
  );
}

GetPlaylists.PATH = '/api/Parent/GetPlaylists';
